import { SelectListItem } from '../common/select.list.item';

export class TyreFilterDescriptions {
  Stock: SelectListItem[];
  Categories: SelectListItem[];
  Brands: SelectListItem[];
  Runflat: SelectListItem[];
}
